/* Pagination: "1 to 20 of 64" with previous/next. Arrows follow reading direction. */
import { CaretLeft, CaretRight } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/cn'
import { useFormat } from '@/i18n/useFormat'

export function Pagination({
  page,
  pageSize,
  total,
  onPageChange,
  className,
}: {
  page: number
  pageSize: number
  total: number
  onPageChange: (page: number) => void
  className?: string
}) {
  const { t } = useTranslation('common')
  const f = useFormat()
  const pages = Math.max(1, Math.ceil(total / pageSize))
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1
  const to = Math.min(total, page * pageSize)
  const btn =
    'inline-flex h-8 items-center gap-1 rounded-[10px] px-2.5 text-13 font-medium text-body ring-1 ring-hairline-strong ring-inset transition-colors hover:bg-surface-soft disabled:pointer-events-none disabled:opacity-40 touch:min-h-11'
  return (
    <nav
      aria-label={t('ui.pagination.label')}
      className={cn('flex items-center justify-between gap-3', className)}
    >
      <p className="figures text-13 text-subtle">
        {t('ui.pagination.range', { from: f.number(from), to: f.number(to), total: f.number(total) })}
      </p>
      {pages > 1 ? (
        <div className="flex items-center gap-1.5">
          <button type="button" className={btn} disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
            <CaretRight className="size-3.5 flip-ltr" aria-hidden="true" />
            {t('ui.pagination.previous')}
          </button>
          <button
            type="button"
            className={btn}
            disabled={page >= pages}
            onClick={() => onPageChange(page + 1)}
          >
            {t('ui.pagination.next')}
            <CaretLeft className="size-3.5 flip-ltr" aria-hidden="true" />
          </button>
        </div>
      ) : null}
    </nav>
  )
}
